import apiClient from '../apiClient';
import { API_ENDPOINTS } from '../endpoints';

export interface GameHistoryListItem {
  id: string;
  historyId: string;
  roomId: string;
  betAmount: number;
  commissionPercent: number;
  startedAt: string;
  finishedAt: string;
  durationMs: number;
  playersCount: number;
  totalCartelasSold: number;
  prizePool: number;
  netPrizePool: number;
  platformRevenue: number;
  winnersCount: number;
  callIndex: number;
  winnerCallIndex: number | null;
  createdAt: string;
}

export interface GameHistoryWinner {
  userId: string;
  telegramId: string;
  displayName: string;
  cartelaNumber: number;
  pattern: string;
  patternName: string;
  callIndex: number;
  prizeAmount: number;
  balanceBefore?: number;
  balanceAfter?: number;
  grid: {
    B: (number | null)[];
    I: (number | null)[];
    N: (number | null)[];
    G: (number | null)[];
    O: (number | null)[];
  } | null;
  winningCells: Array<{
    letter: string;
    row: number;
    value: number | null;
  }>;
}

export interface GameHistoryPlayer {
  userId: string;
  telegramId: string;
  displayName: string;
  cartelaNumbers: number[];
  wonCartelas: number[];
  lockedCartelas: number[];
  balanceBefore?: number;
  balanceAfter?: number;
  totalBet?: number;
  totalWon?: number;
}

export interface GameHistoryDetail extends GameHistoryListItem {
  sequence: number[];
  calledNumbers: number[];
  remainingNumbers: number[];
  winners: GameHistoryWinner[];
  players: GameHistoryPlayer[];
  totalPrizeDistributed?: number;
}

export interface Pagination {
  page: number;
  limit: number;
  total: number;
  pages: number;
}

export interface GameHistoryResponse {
  games: GameHistoryListItem[];
  pagination: Pagination;
}

interface ApiEnvelope<T> {
  success: boolean;
  data: T;
}

export interface GetGameHistoryParams {
  page?: number;
  limit?: number;
  search?: string;
  minDate?: string;
  maxDate?: string;
}

class GameHistoryService {
  async getAll(params: GetGameHistoryParams = {}): Promise<GameHistoryResponse> {
    const res = await apiClient.get<ApiEnvelope<GameHistoryResponse>>(
      API_ENDPOINTS.GAME_HISTORY.GET_ALL,
      { params }
    );
    return res.data.data;
  }

  async getOne(id: string): Promise<GameHistoryDetail> {
    const res = await apiClient.get<ApiEnvelope<GameHistoryDetail>>(
      API_ENDPOINTS.GAME_HISTORY.GET_ONE(id)
    );
    return res.data.data;
  }
}

const gameHistoryService = new GameHistoryService();
export default gameHistoryService;